import { THICKNESS_OPTIONS } from './cushionConstants';

const ThicknessButtons = ({ value, onChange, unit = 'cm' }) => {
  return (
    <div className="flex flex-wrap gap-1.5 sm:gap-3" data-testid="thickness-buttons">
      {THICKNESS_OPTIONS.map(opt => {
        const isSelected = value === opt.value;
        const label = unit === 'mm' ? opt.labelMm : opt.labelCm;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            className={`px-3 sm:px-4 py-2 sm:py-2.5 rounded-lg sm:rounded-xl border-2 text-xs sm:text-sm font-semibold transition-all duration-200 cursor-pointer ${
              isSelected
                ? 'bg-teal-600 border-teal-600 text-white shadow-sm'
                : 'bg-white border-gray-200 text-gray-700 hover:border-gray-300 hover:bg-gray-50'
            }`}
            data-testid={`thickness-option-${opt.value}`}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default ThicknessButtons;
